import { supabase } from '@/integrations/supabase/client';

const BASE = () => (import.meta.env.VITE_SUPABASE_URL as string) ?? 'https://beta.crm-api.primetecia.com.br/api';

export type GrupoNumero = 'contato_real' | 'passado' | 'representante' | 'dono' | 'socio' | 'outro';

export interface NumeroParaLigar {
  telefone: string;
  grupo: GrupoNumero;
  rotulo: string;
  origens: string[];
  operadora: string | null;
  whatsapp: boolean | null;
  nao_perturbe: boolean;
  quarentena_ate: string | null;
  ultimo_desfecho: string | null;
  ultima_ligacao: string | null;
}

export interface ListaDeNumeros {
  lead_id: string;
  numeros: NumeroParaLigar[];
  fora: { fixos: number; da_equipe: number; nao_e_daqui?: number };
}

/** Os celulares do lead na ordem do Auto Dialer (services/leads/numeros-para-ligar.ts). */
export async function buscarNumerosParaLigar(leadId: string): Promise<ListaDeNumeros> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sessão expirada — faça login novamente.');
  const response = await fetch(`${BASE()}/v1/leads-carteira/${leadId}/numeros-para-ligar`, {
    headers: { Authorization: `Bearer ${session.access_token}` },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body?.error || 'Não foi possível buscar os números deste lead.');
  return body.data as ListaDeNumeros;
}
